import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
export const ToastIconContainer = styled("div")`
    // Ensure we wrap the Icon itself with no extra default spacing.
    display: inline-flex;

    margin: ${space.space30} 0 ${space.space30} ${space.space30};

    color: ${_ref => {
  let {
    iconColor
  } = _ref;
  return iconColor;
}};
`;
//# sourceMappingURL=ToastIconContainer.js.map